import { makeRequest } from '../utils/apiUtils';
import { addRemoteScript } from '../utils/htmlUtils';

export const GET_FACEBOOK_URL_INFO = "social/GET_FACEBOOK_URL_INFO";
export const GET_FACEBOOK_URL_INFO_SUCCESS = "social/GET_FACEBOOK_URL_INFO_SUCCESS";
export const GET_FACEBOOK_URL_INFO_FAIL = "social/GET_FACEBOOK_URL_INFO_FAIL";

export const GET_VK_URL_INFO = "social/GET_VK_URL_INFO";
export const GET_VK_URL_INFO_SUCCESS = "social/GET_VK_URL_INFO_SUCCESS";
export const GET_VK_URL_INFO_FAIL = "social/GET_VK_URL_INFO_FAIL";

export function getFacebookUrlInfo(url) {
  return dispatch =>
    makeRequest(`https://graph.facebook.com/?id=${encodeURIComponent(url)}`, {
      types: [GET_FACEBOOK_URL_INFO, GET_FACEBOOK_URL_INFO_SUCCESS, GET_FACEBOOK_URL_INFO_FAIL],
      apiOptions: { ignore403: true },
      url
    })(dispatch)
      .catch(err => {})
  ;
}

let vkCountCounter = 0;
const vkCountCallbacks = {};

const VK = (window ? (window.VK = window.VK || {}) : {});
VK.Share = VK.Share || {};
const oldCount = VK.Share.count;
VK.Share.count = function (index, count) {
  if (vkCountCallbacks[index]) {
    vkCountCallbacks[index](index, count);
  }

  if (oldCount) {
    oldCount(index, count);
  }
}

export function getVkUrlInfo(url) {
  return dispatch => {
    const additional = { url };

    dispatch({ type: GET_VK_URL_INFO, additional })

    vkCountCallbacks[vkCountCounter] = (index, shareCount) => dispatch({
      type: GET_VK_URL_INFO_SUCCESS,
      response: { shareCount },
      additional
    });

    addRemoteScript(`https://vk.com/share.php?act=count&index=${vkCountCounter}&url=${encodeURIComponent(url)}`)
      .catch(err => dispatch({
        type: GET_VK_URL_INFO_FAIL,
        response: err,
        additional
      }))
    ;

    vkCountCounter++;
  };
}
